import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { DSType } from '../../../TypesTableContext'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<DSType>[] => {
  return [
    useNameColumn({
      help: HelpMessage.DesignSubmittals.Types.Name,
      width: 300,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Type'),
  ]
}
